var CourseSettingsService = require('services/course-settings-service');
var MemoryStorageService = require('services/memory-storage-service');
var utils = require('lib/utils');
const ef = require('ef/ef');

var MenuService = {
  autoPlay: function() {
    var menu = CourseSettingsService.get('menu');
    let modules = [];
    let options = Object.assign({}, menu.autoplay);
    if(EF.enrollment.get('demoMode') && menu.auto_play_demo) {
      Object.assign(options, menu.auto_play_demo);
    }

    var lastInProgress = _.find(options.modules, function(moduleKey) {
      var module = EF.modules.getModuleByKey(moduleKey);
      var plays = MemoryStorageService.get(`${moduleKey}:plays`) || 0;
      return module && !module.get('locked') && module.get('completed') === false &&
        (options.limit === undefined || plays < options.limit);
    });

    if(lastInProgress) {
      var plays = (MemoryStorageService.get(`${lastInProgress}:plays`) || 0) + 1;
      MemoryStorageService.set(`${lastInProgress}:plays`, plays);
      utils.redirectToModule(EF.modules.getModuleByKey(lastInProgress));
    }
  },
  getUnlockDay(){
    let startDateCustomization = CourseSettingsService.get('start_date');
    if (startDateCustomization){
      return utils.daysFromToday(startDateCustomization);
    }
  }
};

module.exports = MenuService;
